import Footer from './Footer';
import Header from './Header';
import style from './main.less';
const Main = ({children}) => {
    return (
        <div className={style.layout}>
            <Header />
            <div className={style.body}>{children}</div>
            <Footer />
        </div>
    );
};

export default Main;
